<template>
  <div class="tw-bg-white tw-rounded-lg tw-border tw-overflow-hidden tw-border-gray-200">
    <div class="tw-overflow-x-auto">
      <table class="tw-min-w-full tw-leading-normal">
        <thead>
          <tr>
            <th v-for="c in columns" :key="c.name" :class="c.classes"
              class="tw-px-5 last:tw-border-e-0 tw-whitespace-nowrap tw-border-e tw-py-3 tw-border-b tw-border-gray-100 tw-bg-gray-50 tw-text-start tw-text-[12px] tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider">
              {{ $t(c.label, c.fallback) }}
            </th>
          </tr>
        </thead>

        <!-- Loading skeleton -->
        <tbody v-if="props.loading">
          <tr class="tw-border-b tw-border-solid tw-border-gray-100 last:tw-border-b-0 tw-group even:tw-bg-gray-50/50"
            v-for="i in 10" :key="i">
            <td v-for="c in columns" :key="c.name" class="tw-px-2 tw-py-3">
              <div class="tw-w-full tw-py-3 tw-bg-gray-50 group-even:tw-bg-white tw-rounded tw-min-w-[30px] tw-animate-pulse"></div>
            </td>
          </tr>
        </tbody>

        <!-- Data -->
        <tbody v-else>
          <template v-if="items.length > 0">
            <VideoTableRow v-for="item in items" :key="item.id + '-' + item.status" :item="item" />
          </template>
          <template v-else>
            <tr>
              <td :colspan="columns.length">
                <div class="tw-p-5 tw-bg-white tw-min-h-[250px] tw-text-gray-600 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2">
                  <icon icon="solar:videocamera-record-broken-bold-duotone" class="tw-text-5xl tw-text-gray-300" />
                  <p>{{ $t('videos.empty', 'No videos yet.') }}</p>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>

  <div class="tw-my-4"></div>

  <TablePagination
    v-if="items.length > 0"
    :has-next="!!options.next_page_url"
    :has-previous="!!options.prev_page_url"
    @previous="emit('previous')"
    @next="emit('next')"
  />
</template>

<script setup>
import { ref, defineProps, toRef, defineEmits } from 'vue';
import TablePagination from '@/components/table/TablePagination';
import VideoTableRow from './VideoTableRow';

const props = defineProps(['loading', 'items', 'options']);
const items = toRef(props, 'items');
const emit = defineEmits(['next', 'previous']);

const columns = ref([
    { name: 'id', label: 'fields.id', fallback: 'ID', classes: ['tw-w-[40px] tw-whitespace-nowrap'] },
    { name: 'video', label: 'videos.col-video', fallback: 'Video', classes: [] },
    { name: 'source', label: 'videos.col-source', fallback: 'Source', classes: ['tw-whitespace-nowrap'] },
    { name: 'categories', label: 'videos.col-categories', fallback: 'Categories', classes: [] },
    { name: 'duration', label: 'videos.duration', fallback: 'Duration', classes: ['tw-w-[90px] tw-text-center'] },
    { name: 'views', label: 'videos.col-views', fallback: 'Views', classes: ['tw-w-[80px] tw-text-center'] },
    { name: 'status', label: 'videos.col-status', fallback: 'Status', classes: ['tw-w-[80px] tw-text-center'] },
    { name: 'created_at', label: 'videos.col-created', fallback: 'Created', classes: ['tw-w-[120px] tw-text-center'] },
    { name: 'actions', label: 'fields.actions', fallback: 'Actions', classes: ['tw-w-[120px] tw-whitespace-nowrap'] },
]);
</script>

<style></style>
